module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": false,
      "customClass": 'heightAuto',
      "footer": true
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h2', {
    staticClass: "text-center mb-3"
  }, [_vm._v("Events where this promocode can be used")]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "w-100 text-center"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "eventList"
  }, _vm._l((_vm.eventsList), function(eventsDay) {
    return (_vm.hideDaysWithoutEvents == false || eventsDay.events.length > 0) ? _c('div', {
      staticClass: "w-10."
    }, [_c('div', {
      staticClass: "w-100 bg-light dark bold px-1"
    }, [_vm._v(_vm._s(_vm.getDateToDisplay(eventsDay)))]), _vm._v(" "), (eventsDay.events.length == 0) ? _c('div', [_c('div', {
      staticClass: "w-100 bg-lighter dark text-center"
    }, [_vm._v(" -- no events --")])]) : _c('div', _vm._l((eventsDay.events), function(event) {
      return _c('div', {
        key: event.id,
        staticClass: "w-100 bg-lighter d-flex px-2"
      }, [_c('div', {
        staticClass: "flex-grow-1"
      }, [_vm._v(_vm._s(_vm.getEventName(event)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getEventStartHour(event)))])])
    }), 0)]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between align-items-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('checkbox', {
    model: {
      value: (_vm.hideDaysWithoutEvents),
      callback: function($$v) {
        _vm.hideDaysWithoutEvents = $$v
      },
      expression: "hideDaysWithoutEvents"
    }
  }, [_vm._v("\n                Hide days without events\n            ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pressOk
    }
  }, [_vm._v("Ok")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7d8cf9d3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d8cf9d3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/PromocodeAffectedEvents.vue
// module id = 1041
// module chunks = 0